"use client"

import { useNavigate } from "react-router-dom"
import { FaHome } from "react-icons/fa"
import "./FoundationMembers.css"
import { useEffect, useState } from "react"
import { db } from '../firebase'
import { collection, getDocs, query, orderBy } from 'firebase/firestore'

function getInitials(name = '') {
  return name.split(' ').filter(Boolean).map((part) => part[0]).slice(0, 2).join('').toUpperCase()
}

function FoundationMembers() {
  const navigate = useNavigate()
  const [members, setMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState(null)

  useEffect(()=>{
    const load = async ()=>{
      try{
        const col = collection(db, 'members')
        const q = query(col, orderBy('createdAt'))
        const snap = await getDocs(q)
        const data = snap.docs.map(d=>({ id: d.id, ...d.data() }))
        setMembers(data)
      }catch(err){
        console.error('Failed to load members', err)
      }
    }
    load()
  },[])

  useEffect(()=>{
    if(!selectedMember) return undefined
    const onKeyDown = (event) => {
      if(event.key === 'Escape') setSelectedMember(null)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  },[selectedMember])

  const renderAvatar = (member, enlarged = false) => {
    const photo = member.photoData || member.photoUrl || member.photo || ''
    return (
      <div className={enlarged ? 'member-avatar enlarged' : 'member-avatar'}>
        {photo ? <img src={photo} alt={member.name || 'Foundation member'} /> : <span>{getInitials(member.name)}</span>}
      </div>
    )
  }

  return (
    <section className="foundation-members-page">
      <div className="container">
        <div className="section-header">
          <p className="foundation-members-tagline">Pramila Foundation</p>
          <h2>Foundation Members</h2>
          <div className="underline"></div>
          <p className="section-description">
            Meet the dedicated members guiding Pramila Foundation's mission
          </p>
        </div>

        <div className="members-grid">
          {members.map((member) => (
            <button key={member.id} type="button" className="member-card" onClick={() => setSelectedMember(member)}>
              {renderAvatar(member)}
              <h3 className="member-name">{member.name}</h3>
              <p className="member-role">{member.idNumber || member.memberId || ''}</p>
              <p className="member-description">{[member.district, member.state].filter(Boolean).join(', ')}</p>
            </button>
          ))}
        </div>

        <div className="home-button-container">
          <button className="home-button" onClick={() => navigate("/") }>
            <FaHome className="button-icon" /> Back to Home
          </button>
        </div>
      </div>

      {selectedMember && (
        <div className="member-modal-backdrop" role="presentation" onClick={() => setSelectedMember(null)}>
          <div className="member-modal" role="dialog" aria-modal="true" aria-label={`${selectedMember.name || 'Member'} details`} onClick={(event) => event.stopPropagation()}>
            <button type="button" className="member-modal-close" onClick={() => setSelectedMember(null)} aria-label="Close member details">�</button>
            {renderAvatar(selectedMember, true)}
            <h3 className="member-name">{selectedMember.name}</h3>
            <p className="member-role">{selectedMember.idNumber || selectedMember.memberId || ''}</p>
            <p className="member-description">{[selectedMember.district, selectedMember.state].filter(Boolean).join(', ')}</p>
          </div>
        </div>
      )}
    </section>
  )
}

export default FoundationMembers
